import { render, staticRenderFns } from "./BriefFeedbackList.vue?vue&type=template&id=6e49f03c"
import script from "./BriefFeedbackList.vue?vue&type=script&lang=js"
export * from "./BriefFeedbackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports